import styled from "styled-components";

export const BreadCrumbContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100px;
  margin: 0 5px 20px 5px;
  cursor: pointer;
  /* width: 250px; */
  width: auto;

  .name-link {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: gray;
    font-weight: 600;
    font-size: 13px;
  }
`;
